import React from 'react';
import { LogoMarquee } from './LogoMarquee';
export function TrustedCompanies() {
  return <section className="hidden md:block w-full bg-navy text-white" data-id="element-120">
      <div className="px-6 md:px-12 py-24" data-id="element-121">
        <h3 className="text-sm mb-8 text-white/60 text-center font-medium tracking-wider max-w-6xl mx-auto" data-id="element-122">
          TRUSTED BY WORLD-CLASS COMPANIES LIKE
        </h3>
      </div>
      <LogoMarquee data-id="element-123" />
    </section>;
}